/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import creditCardType from 'credit-card-type';

import { CreditCardKeys, CreditCartTypes } from './types';

creditCardType.updateCard(creditCardType.types[CreditCardKeys.Visa], {
  niceType: CreditCartTypes.Visa,
});
creditCardType.updateCard(creditCardType.types[CreditCardKeys.Mastercard], {
  niceType: CreditCartTypes.Mastercard,
});
creditCardType.updateCard(creditCardType.types[CreditCardKeys.AMEX], {
  niceType: CreditCartTypes.AMEX,
});
creditCardType.updateCard(creditCardType.types[CreditCardKeys.Discover], {
  niceType: CreditCartTypes.Discover,
});

export default function getCreditCardType(value?: string): CreditCartTypes | null {
  if (!value) return null;

  const creditCard = creditCardType(value)[0];
  if (!creditCard?.niceType) return null;
  return creditCardType(value)[0].niceType as CreditCartTypes;
}
